import script from "./BuildingInfoPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingInfoPopup.vue?vue&type=script&setup=true&lang=js"

import "./BuildingInfoPopup.vue?vue&type=style&index=0&id=39683979&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39683979"]])

export default __exports__